import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { useTranslation } from 'react-i18next';

import { styles } from './style';

const useStyles = makeStyles(styles);

export default function DamUseDatalists() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <Box p={2} className={classes.boxContent}>
        <Box pb={2} className={classes.title} alignItems="center">{t('เครื่องมือและอุปกรณ์')}</Box>
        {t('ยังไม่มีการเชื่อมโยงข้อมูล')}
      </Box>
    </>
  );
}
